
import 'quasar/dist/quasar.css'
import lang from 'quasar/lang/es.js'
import iconSet from 'quasar/icon-set/mdi-v4.js'
import '@quasar/extras/roboto-font/roboto-font.css'
import '@quasar/extras/mdi-v4/mdi-v4.css'

// To be used on app.use(Quasar, { ... })
export default {
  config: {},
  plugins: {
  },
  iconSet: iconSet,
  lang: lang
}
